export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=5b2bba1a"


//////////////////
// WEBPACK FOOTER
// ./src/components/content/strings/list.vue?vue&type=template&id=5b2bba1a
// module id = SyyM
// module chunks = 0